import axios from 'axios'
import { ElMessage } from 'element-plus'

const config = {
  baseURL: window.location.origin,
  timeout: 60000
}

const api = axios.create(config)

api.post = function (url, dataParams, callBack, errorCallBack, type = 1) {
  return new Promise((resolve, reject) => {
    let content = {
      method: 'post',
      url: config.baseURL + url,
      data: dataParams
    }
    if (type === 1) {
      content.transformRequest = [function (data) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        ret = ret.substr(0, ret.length - 1)
        return ret
      }]
    }
    axios(content).then(res => {
      if (res.status == 200) {
        if (typeof callBack == 'function') {
          callBack(res)
          resolve(res)
        }
      } else {
        if (typeof errorCallBack == 'function') {
          errorCallBack(res)
        }
        reject(res)
      }
    })
  })
}

api.get = function (url, dataParams, callBack, errorCallBack) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: config.baseURL + url,
      params: dataParams
    }).then(res => {
      if (res.status == 200) {
        if (typeof callBack == 'function') {
          callBack(res)
        }
        resolve(res)
      } else {
        if (typeof errorCallBack == 'function') {
          errorCallBack(res)
        }
        reject(res)
      }
    })
  })
}

axios.interceptors.response.use(
  res => {
    if (res.data.success) {
      return Promise.resolve(res);
    } else {
      ElMessage({
        message: '服务器异常，请稍后再试',
        type: 'error'
      })
      return Promise.reject(res);
    }
  }, error => {
    if (error.response.status) {
      ElMessage({
        message: '服务器异常，请稍后再试',
        type: 'error'
      })
      return Promise.reject(error.response);
    }
  }
)

export default api
